import NlpAgent from './NlpAgent';

export { NlpAgent };



// WEBPACK FOOTER //
// src/modules/screens/settings/NlpAgent/components/index.js